export const DateFormats = {
    parse: {
        dateInput: ['DD.MM.yyyy']
    },
    display: {
        dateInput: 'L',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};